import { Stack } from '@mui/material';
import { type FC } from 'react';
import { VoiceAction } from '../../types/voice';
import { ActionCardCreateAchievementView } from './ActionCardCreateAchievementView';
import { ActionCardCreateCategoryView } from './ActionCardCreateCategoryView';
import { ActionCardCreateQuestView } from './ActionCardCreateQuestView';
import { ActionCardDependentLine } from './ActionCardDependentLine';
import { ActionCardPostponeView } from './ActionCardPostponeView';
import { ActionCardTitle } from './ActionCardTitle';
import { ActionCardTypeLabel } from './ActionCardTypeLabel';

interface ActionCardViewProps {
  action: VoiceAction;
  dependentActions?: VoiceAction[];
}

export const ActionCardView: FC<ActionCardViewProps> = ({ action, dependentActions }) => {
  return (
    <Stack flex={1} minWidth={0}>
      <ActionCardDependentLine dependentActions={dependentActions} />
      <ActionCardTypeLabel type={action.type} />
      <ActionCardTitle action={action} />
      <Stack direction="row" alignItems="center" gap={0.5} flexWrap="wrap" sx={{ minWidth: 0 }}>
        {action.type === 'CREATE_QUEST' && (
          <ActionCardCreateQuestView action={action} />
        )}
        {action.type === 'CREATE_CATEGORY' && (
          <ActionCardCreateCategoryView action={action} />
        )}
        {action.type === 'POSTPONE_QUEST' && (
          <ActionCardPostponeView action={action} />
        )}
        {action.type === 'CREATE_ACHIEVEMENT' && (
          <ActionCardCreateAchievementView action={action} dependentActions={dependentActions} />
        )}
      </Stack>
    </Stack>
  );
};
